import {Route} from "../../model/Wall";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBookmark} from "@fortawesome/free-solid-svg-icons";
import {faBookmark as farBookmark} from "@fortawesome/free-regular-svg-icons";

export default function RouteInfoList({route, isBookmarkDisabled, onBookmarkClick, bookmarked}) {
    const labelStyles = "py-2 pr-6 font-semibold";
    const valueStyles = "py-2 flex items-center";
    const color = Route.getColorHexString(route);
    return (
        <div id="route-info-list" className="bg-gray-700 px-6 py-4 rounded-lg shadow-md">
            <table>
                <tbody>
                <tr>
                    <td className={labelStyles}>Name</td>
                    <td className={valueStyles}>{route.name ?? "?"}</td>
                </tr>
                <tr>
                    <td className={labelStyles}>Builder</td>
                    <td className={valueStyles}>{route.builder ?? "?"}</td>
                </tr>
                <tr>
                    <td className={labelStyles}>Difficulty</td>
                    <td className={valueStyles}>{route.difficulty ?? "?"}</td>
                </tr>
                <tr>
                    <td className={labelStyles}>Created</td>
                    <td className={valueStyles}>{Route.getCreationDateString(route) ?? "?"}</td>
                </tr>
                <tr>
                    <td className={labelStyles}>Color</td>
                    <td className={`${valueStyles} flex items-center space-x-2`}>
                        {color !== null &&
                            <div
                                className="h-6 w-6 rounded-full"
                                style={{ backgroundColor: color }}
                            ></div>
                        }
                        {color === null && "?"}
                    </td>
                </tr>
                <tr>
                    <td className={labelStyles + (isBookmarkDisabled ? "" : " cursor-pointer")}
                        onClick={onBookmarkClick}
                    >Bookmark
                    </td>
                    <td className={valueStyles}>
                        <FontAwesomeIcon
                            icon={bookmarked ? faBookmark : farBookmark}
                            className={"mt-0.5 ml-1" + (isBookmarkDisabled ? "" : " cursor-pointer")}
                            size={"lg"}
                            onClick={onBookmarkClick}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}